import api from './base'

export default {
  getAll ({ childCompanyId, businessUnitId }) {
    return api().get(`company/child_companies/${childCompanyId}/business_units/${businessUnitId}/electronic_devices`)
  },
  getById ({ childCompanyId, businessUnitId, deviceId }) {
    return api().get(`company/child_companies/${childCompanyId}/business_units/${businessUnitId}/electronic_devices/${deviceId}`)
  },
  save ({ childCompanyId, businessUnitId, item }) {
    return api().put(`company/child_companies/${childCompanyId}/business_units/${businessUnitId}/electronic_devices`, item)
  },
  delete ({ childCompanyId, businessUnitId, deviceId }) {
    return api().delete(`company/child_companies/${childCompanyId}/business_units/${businessUnitId}/electronic_devices/${deviceId}`)
  },
  deregister ({ childCompanyId, businessUnitId, electronicDeviceId }) {
    return api().delete(`company/child_companies/${childCompanyId}/business_units/${businessUnitId}/electronic_devices/${electronicDeviceId}/activation`)
  },
  turnFiscalizationOn ({ childCompanyId, businessUnitId, electronicDeviceId, deleteData }) {
    return api().put(`company/child_companies/${childCompanyId}/business_units/${businessUnitId}/electronic_devices/${electronicDeviceId}/fiscalization?deleteData=${deleteData}`)
  },
  turnFiscalizationOff ({ childCompanyId, businessUnitId, electronicDeviceId }) {
    return api().delete(`company/child_companies/${childCompanyId}/business_units/${businessUnitId}/electronic_devices/${electronicDeviceId}/fiscalization`)
  },
  setHeader ({ childCompanyId, businessUnitId, electronicDeviceId, header }) {
    return api().put(`company/child_companies/${childCompanyId}/business_units/${businessUnitId}/electronic_devices/${electronicDeviceId}/invoice_header`, { data: header })
  },
  getHeader ({ childCompanyId, businessUnitId, electronicDeviceId }) {
    return api().get(`company/child_companies/${childCompanyId}/business_units/${businessUnitId}/electronic_devices/${electronicDeviceId}/invoice_header`)
  },
  setFooter ({ childCompanyId, businessUnitId, electronicDeviceId, footer }) {
    return api().put(`company/child_companies/${childCompanyId}/business_units/${businessUnitId}/electronic_devices/${electronicDeviceId}/invoice_footer`, { data: footer })
  },
  getFooter ({ childCompanyId, businessUnitId, electronicDeviceId }) {
    return api().get(`company/child_companies/${childCompanyId}/business_units/${businessUnitId}/electronic_devices/${electronicDeviceId}/invoice_footer`)
  },
  enable ({ childCompanyId, businessUnitId, electronicDeviceId }) {
    return api().put(`company/child_companies/${childCompanyId}/business_units/${businessUnitId}/electronic_devices/${electronicDeviceId}/enabling`)
  },
  disable ({ childCompanyId, businessUnitId, electronicDeviceId }) {
    return api().delete(`company/child_companies/${childCompanyId}/business_units/${businessUnitId}/electronic_devices/${electronicDeviceId}/enabling`)
  }
}
